import axios from '@services/HTTP'
import { useDiscoveryStore } from 'store/discovery'

type MSG = {
  timestamp: number
  _id: string
  data?: string
  role: string
  content: string
}

export const askEvaroLog = async (msg: MSG) => {
  return axios.post<{ _id: string }, { _id: string }>('/connect/ask_evaro/log', msg, {
    baseURL: process.env.NEXT_PUBLIC_NODE_API_URL,
    headers: {
      Authorization: null
    }
  })
}

export const askEvaroLogClient = async (message: string, data?: string) => {
  const log = await askEvaroLog({
    role: 'event',
    content: message,
    data,
    timestamp: Date.now(),
    _id: useDiscoveryStore.getState().ID
  })

  useDiscoveryStore.getState().setID(log._id)
  return log
}
